const fragment = `
  id
  isDefault
  imageUrl
`;

export const listProjectBuildingImagesQuery = `
  query ListProjectBuildingImages(
    $filter: ProjectBuildingImageFilterInput
  ) {
    items: listProjectBuildingImages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createProjectBuildingImageQuery = `
  mutation CreateProjectBuildingImage(
    $input: CreateProjectBuildingImageInput!
    $image: Upload
  ) {
    item: createProjectBuildingImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateProjectBuildingImageQuery = `
  mutation UpdateProjectBuildingImage(
    $input: UpdateProjectBuildingImageInput!
    $image: Upload
  ) {
    item: updateProjectBuildingImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteProjectBuildingImageQuery = `
  mutation DeleteProjectBuildingImage(
    $id: Int!
  ) {
    item: deleteProjectBuildingImage(id: $id) {
      ${fragment}
    }
  }
`;

export const sortProjectBuildingImagesQuery = `
  mutation SortProjectBuildingImages(
    $projectBuildingId: Int!,
    $ids: [Int!]!
  ) {
    items: sortProjectBuildingImages(projectBuildingId: $projectBuildingId, ids: $ids) {
      id
    }
  }
`;
